import { configDialogFactory, configSablier, configEncodeUrlAkto } from "../extensions";
import type { FetchConfig } from "../types";

export const habilitations = [configSablier, configEncodeUrlAkto, configDialogFactory()] as Array<FetchConfig>
